'use strict';

// Entry point
jQuery(function() {

    var webphoneUI = new WebphoneUI();

    webphoneUI.init();

    webphoneUI.sipLogin = '';
    webphoneUI.sipPassword = '';

    if (webphoneUI.sipLogin
        && webphoneUI.sipPassword)
        webphoneUI.login();

    // Expose this object to globals
    window.webphoneObject = webphoneUI;

/** /
    webphoneUI.phone.iceServers = [
        {
            'urls': ['stun:isrv1.il-online.ru']
        },
    ];
/**/

    //webphoneUI.phone.soundPleer('answered', 0);

/** /
    webphoneUI.phone.playSound('ringing');
    webphoneUI.phone.playSound('ringback');

    setTimeout(function() {
        webphoneUI.phone.playSound('answered');
        webphoneUI.phone.playSound('ringing');
        webphoneUI.phone.playSound('ringback');
        webphoneUI.phone.playSound('rejected');

        setTimeout(function() {
            webphoneUI.phone.playSound('ringback');
            webphoneUI.phone.playSound('answered');
            webphoneUI.phone.playSound('rejected');
            webphoneUI.phone.playSound('ringing');

            setTimeout(function() {
                webphoneUI.phone.playSound('rejected');
                webphoneUI.phone.playSound('ringing');
                webphoneUI.phone.playSound('ringback');
                webphoneUI.phone.playSound('answered');
            }, 5000);
        }, 5000);
    }, 5000);
    return;
/**/

/** /
    var called = false;
    webphoneUI.addEventListener('registered', function() {
        if (!called) {
            called = true;
            var obj = this;

            setTimeout(function() {
                obj.phone.call('sip:*60@webphoneUI.domain');
            }, 3500);
        }
    });
/**/

/** /
    setInterval(function() {
        jQuery('.window-allow-soundpleer').show();
    }, 1000);
/**/
});
